module.exports = __webpack_public_path__ + "img/tab_button_img2.e5d48ecb.png";